<template>
  <div>
    <el-dialog title="试卷总评"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="500rem"
               :before-close="handleClose">
      <el-row :gutter="10">
        <el-col :span="24"
                class="center_col">
          <span>评价:</span>
          <el-input clearable
                    placeholder="请输入试卷总评"
                    type="textarea"
                    v-model="form.user_paper_comment"
                    style="width:85%"
                    :rows="4" />
        </el-col>
      </el-row>
      <el-row style="text-align:center">
        <el-button type="primary"
                   @click="handleClose">提交</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {},
      dialogVisible: false,
    }
  },
  methods: {
    handleClose () {
      this.$parent.postUserPaper(this.form)
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.center_col {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin-right: 10rem;
    font-size: 18rem;
    font-weight: bold;
  }
}
.el-row {
  &:nth-child(1) {
    display: flex;
    justify-content: center;
    margin-bottom: 10rem;
  }
}

::v-deep .el-dialog__header {
  font-size: 20rem;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4rem;
}
</style>